import type { Settings } from './settings';

const EMOJI_RE = /[\p{Extended_Pictographic}\p{Emoji_Component}‍️\s]/gu;
const LINK_RE = /(https?:\/\/|www\.|\b[a-z0-9-]+\.(com|net|org|my|id|io|co|me|tv|link)\b)/i;

export interface FilterState {
  recent: Map<string, number>;
}

export const newFilterState = (): FilterState => ({ recent: new Map() });

/** Returns the text to read, or null when the comment should be skipped. */
export function filterComment(text: string, f: Settings['filters'], state: FilterState, now = Date.now()): string | null {
  let t = text.trim();
  if (!t) return null;
  if (f.prefix) {
    if (!t.startsWith(f.prefix)) return null;
    t = t.slice(f.prefix.length).trim();
    if (!t) return null;
  }
  if (f.skipLinks && LINK_RE.test(t)) return null;
  if (f.skipEmojiOnly && t.replace(EMOJI_RE, '').length === 0) return null;
  if (f.blocklist) {
    const words = f.blocklist
      .split(',')
      .map((w) => w.trim().toLowerCase())
      .filter(Boolean);
    const lower = t.toLowerCase();
    if (words.some((w) => lower.includes(w))) return null;
  }
  if (f.maxLength > 0 && t.length > f.maxLength) t = t.slice(0, f.maxLength).replace(/\s+\S*$/, '') + '…';
  if (f.dedupe) {
    const key = t.toLowerCase().replace(/\s+/g, ' ');
    for (const [k, ts] of state.recent) if (now - ts > 60_000) state.recent.delete(k);
    if (state.recent.has(key)) return null;
    state.recent.set(key, now);
  }
  return t;
}

/** Cheap script-based language guess for picking a voice. */
export function detectLang(text: string): 'zh' | 'ta' | 'ja' | 'ko' | 'th' | 'ar' | null {
  if (/[一-鿿㐀-䶿]/.test(text)) return 'zh';
  if (/[぀-ヿ]/.test(text)) return 'ja';
  if (/[가-힯]/.test(text)) return 'ko';
  if (/[஀-௿]/.test(text)) return 'ta';
  if (/[฀-๿]/.test(text)) return 'th';
  if (/[؀-ۿ]/.test(text)) return 'ar';
  return null;
}
